import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Mail, Heart, MessageCircle } from "lucide-react";
import Header from "../components/Header";

const Card = ({ icon: Icon, title, children }) => (
  <div className="bg-white/80 backdrop-blur-xl border border-[#EADDD7] rounded-3xl p-6 soft-shadow">
    <div className="h-10 w-10 rounded-full bg-[#F2E8E9] flex items-center justify-center mb-4">
      <Icon className="h-5 w-5 text-[#9B6A6C]" />
    </div>
    <h3 className="text-lg font-medium text-[#2C2123] mb-2">{title}</h3>
    <div className="text-[#5C4B51] leading-relaxed text-sm">{children}</div>
  </div>
);

const Contact = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen trubeaute-gradient">
      <Header />
      <main
        className="pt-32 pb-24 px-6 max-w-4xl mx-auto"
        data-testid="contact-page"
      >
        <div className="text-center mb-12">
          <span className="inline-block text-xs uppercase tracking-[0.25em] text-[#9B6A6C] mb-3">
            {t("contact.kicker")}
          </span>
          <h1 className="text-4xl sm:text-5xl font-light text-[#2C2123] leading-tight mb-4">
            {t("contact.headline1")}{" "}
            <span className="font-serif italic text-[#5D4050]">
              {t("contact.headlineItalic")}
            </span>
            {t("contact.headlineDot")}
          </h1>
          <p className="text-[#5C4B51] max-w-xl mx-auto">
            {t("contact.subline")}
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-5">
          <Card icon={Mail} title={t("contact.generalTitle")}>
            <a
              href="mailto:hello@trubeaute.com"
              className="text-[#9B6A6C] underline"
              data-testid="contact-email-general"
            >
              hello@trubeaute.com
            </a>
            <p className="mt-2">{t("contact.generalBody")}</p>
          </Card>
          <Card icon={MessageCircle} title={t("contact.supportTitle")}>
            <a
              href="mailto:support@trubeaute.com"
              className="text-[#9B6A6C] underline"
              data-testid="contact-email-support"
            >
              support@trubeaute.com
            </a>
            <p className="mt-2">{t("contact.supportBody")}</p>
          </Card>
          <Card icon={Heart} title={t("contact.partnersTitle")}>
            <a
              href="mailto:partners@trubeaute.com"
              className="text-[#9B6A6C] underline"
              data-testid="contact-email-partners"
            >
              partners@trubeaute.com
            </a>
            <p className="mt-2">{t("contact.partnersBody")}</p>
            <Link to="/partners" className="inline-block mt-3 text-[#9B6A6C] underline">
              {t("contact.explorePartners")}
            </Link>
          </Card>
        </div>

        <p className="text-center text-xs text-[#8A7D82] mt-12">
          {t("contact.footer")}
        </p>
      </main>
    </div>
  );
};

export default Contact;
